import React from 'react';
import s from './FilterPanel.module.css';
import sMain from '../CategoryDisplay/CategoryDisplay.module.css';
import { SwatchDataResponse, SwatchDataSingle } from '../../modules/swatch-data/swatch-data';
import { IProduct } from 'shopify-api-node';
import Collapsible from 'react-collapsible';

import { Affix } from 'antd';
import { FilterByTitle } from '../atoms/FilterByTitle';
import { AppliedFiltersSection } from '../atoms/AppliedFiltersSection';
export type FiltersOpen = {
  [filterName: string]: boolean;
}

export type Filter = {
  name: string;
  options: { name: string, count: number }[];
}

export type FiltersSelected = {
  [filterName: string]: string; //filterValue
}
export type FilterPanelProps = {

  openFilters: FiltersOpen,
  setOpenFilters: React.Dispatch<React.SetStateAction<FiltersOpen>>,
  colors: string[],
  colorData: SwatchDataSingle[],
  groupData: SwatchDataResponse["groups"],
  filteredProducts: IProduct[],
  allProducts: IProduct[],
  selectedColor: string,
  setSelectedColor: (value: string) => unknown,
  filterData: Filter[],
  filtersSelected: FiltersSelected,
  setFilterSelected: (filterName: string, filterOptionName: string) => void,
  clearAllFilters: () => unknown,
}

export const FilterPanel: React.FC<FilterPanelProps> = ({
  openFilters,
  setOpenFilters,
  colors,
  colorData,
  allProducts,
  selectedColor,
  setSelectedColor,
  filterData,
  filtersSelected,
  setFilterSelected,
  clearAllFilters,
  groupData
}) => {


  return (
    <div className={s.FilterPanel}>
      <Affix offsetTop={0}>
        <Collapsible
          classParentString={s.Collapsible}
          contentOuterClassName={s.FilterSectionCollapsibleWrapper}
          trigger={
            <button
              type="button" className={["mobile-filter-trigger", s.FilterOpenTrigger].join(' ')}>
              Filter By
               <span className='minus'>✕</span><span className='plus'>+</span>
            </button>
          }
          open={window.innerWidth >= 991 ? true : false}
        >
          <FilterByTitle>Filter By:</FilterByTitle>
          <div className={s.FilterSection}>
            <div className={s.TitleContainer}>
              <div className={s.ToggleContainer} >
                <button
                  className={[s.ToggleButtonNew, openFilters.color ? s.Opened : false].filter(Boolean).join(' ')}
                  onClick={() => setOpenFilters({ ...openFilters, color: !openFilters.color })}
                >
                  <h4 className={s.FilterTitle}>Color</h4>
                  <div className={s.PlusMinusContainer}>
                    {openFilters.color ? <span className="minus">✕</span> : <span className="plus">+</span>}
                  </div>
                </button>
              </div>
            </div>
            <div className={[s.FilterContent, !openFilters.color ? s.Hide : undefined].join(' ')}>
              {colors.map(color => {
                const foundGroup = groupData.find((x, c) => x.title === color);
                const count = allProducts.reduce((sum, nextProduct) => {
                  const foundVariantColor = nextProduct.variants.find((variant) => {
                    const variantColor = variant.option1;
                    const variantColorIsInGroup = !(variantColor && foundGroup) ? false
                      : foundGroup.colors.find(groupColor => groupColor.toLowerCase() === variantColor.toLowerCase())
                      return variantColorIsInGroup
                  })                  
                  return foundVariantColor
                    ? sum + 1
                    : sum;
                }, 0);
                return (
                  <div
                    key={'color-' + color + '-c'}
                    className={s.FilterOptionContainer}
                  >
                    <div className={[sMain.VerticalCenter, sMain.SmallFont].join(' ')}>
                      <label className={s.container}>
                        <input
                          type="checkbox"
                          checked={selectedColor === color}
                          onChange={() => setSelectedColor(selectedColor === color ? '' : color)}
                          className={s.ValueCheckBox}
                        />
                        <span className={s.checkmark}></span>
                      </label>
                    </div>
                    <div className={[ sMain.VerticalCenter, sMain.SmallFont, foundGroup ? 'swatch-img' : false].filter(Boolean).join(' ')}>
                      {foundGroup ?
                        <img alt={`${color} Swatch`} className={s.ValueSwatch} src={foundGroup.file} /> :
                        <div className={s.ValueSwatch}></div>
                      }
                    </div>
                    <div className={[sMain.VerticalCenter, sMain.SmallFont, s.ValueLabelContainer].join(' ')}>
                      <span className={s.ValueLabel}>{color}</span>
                    </div>
                    <div className={[sMain.VerticalCenter, sMain.SmallFont, s.ValueCountContainer].join(' ')}>
                      <span className={s.ValueCount}>({count})</span>
                    </div>
                  </div>)
              }
              )}
            </div>
          </div>
          {
            filterData.map(filter => {
              const isFilterOpen = openFilters[filter.name];
              const updatedFiltersOnClick = { ...openFilters };
              updatedFiltersOnClick[filter.name] = !isFilterOpen;
              const onFilterClick = () => setOpenFilters(updatedFiltersOnClick);
              return (
                <div className={s.FilterSection} key={`filter-${filter.name}`}>
                  <div className={s.TitleContainer}>
                    <div className={s.ToggleContainer} >
                      <button
                        className={[s.ToggleButtonNew, isFilterOpen ? s.Opened : false].filter(Boolean).join(' ')}
                        onClick={onFilterClick}
                      >
                        <h4 className={s.FilterTitle}>{filter.name}</h4>
                        <div className={s.PlusMinusContainer}>
                          {isFilterOpen
                            ? <span className="minus">✕</span>
                            : <span className="plus">+</span>
                          }
                        </div>
                      </button>
                    </div>
                  </div>
                  <div className={[s.FilterContent, !isFilterOpen ? s.Hide : undefined].join(' ')}>
                    {
                      filter.options.map(filterOption => {
                        const isFilterOptionSelected = filtersSelected[filter.name] === filterOption.name;
                        const onFilterOptionClick = () => setFilterSelected(filter.name, isFilterOptionSelected ? '' : filterOption.name);
                        return (
                          <div
                            key={`filter-option-${filter.name}-${filterOption.name}`}
                            className={s.FilterOptionContainer}
                          >
                            <div className={[sMain.VerticalCenter, sMain.SmallFont].join(' ')}>
                              <label className={s.container}>
                                <input
                                  type="checkbox"
                                  checked={isFilterOptionSelected}
                                  onChange={onFilterOptionClick}
                                  className={s.ValueCheckBox}
                                />
                                <span className={s.checkmark}></span>
                              </label>
                            </div>
                            <div className={[sMain.VerticalCenter, sMain.SmallFont, s.ValueLabelContainer].join(' ')}>
                              <span className={s.ValueLabel}>{filterOption.name}</span>
                            </div>
                            <div className={[sMain.VerticalCenter, sMain.SmallFont, s.ValueCountContainer].join(' ')}>
                              <span className={s.ValueCount}>({filterOption.count})</span>
                            </div>
                          </div>)
                      })
                    }
                  </div>
                </div>
              )
            })
          }
          {
            (Object.keys(filtersSelected).find(x => filtersSelected[x]) || selectedColor) ? (
              <AppliedFiltersSection className="desktop-filters">
                <div className="selected-filters-title">Selected Filters</div>
                <div className="applied-filters">
                  {selectedColor ? <div className={s.SelectedFilter}>
                    <button onClick={() => setSelectedColor('')}>✕</button> {selectedColor}
                  </div> : ''}
                </div>
                {Object.keys(filtersSelected).map(filterName => {
                  if (!filtersSelected[filterName]) return '';
                  return (
                    <div className="applied-filters">
                      <div className={s.SelectedFilter}>
                        <button onClick={() => setFilterSelected(filterName, '')}>✕</button> {filtersSelected[filterName]}
                      </div>
                    </div>
                  );
                })
                }
                <button type="button" className="clear-all-button" onClick={clearAllFilters}>CLEAR ALL</button>
              </AppliedFiltersSection>
            ) : ''
          }
        </Collapsible>
      </Affix>
      {
        (Object.keys(filtersSelected).find(x => filtersSelected[x]) || selectedColor) ? (
          <AppliedFiltersSection className="mobile-filters">
            <div className="selected-filters-title">Selected Filters</div>
            <div className="applied-filters">
              {selectedColor ? <div className={s.SelectedFilter}>
                <button onClick={() => setSelectedColor('')}>✕</button> {selectedColor}
              </div> : ''}
            </div>
            {Object.keys(filtersSelected).map(filterName => {
              if (!filtersSelected[filterName]) return '';
              return (
                <div className="applied-filters">
                  <div className={s.SelectedFilter}>
                    <button onClick={() => setFilterSelected(filterName, '')}>✕</button> {filtersSelected[filterName]}
                  </div>
                </div>
              );
            })
            }
            <button type="button" className="clear-all-button" onClick={clearAllFilters}>CLEAR ALL</button>
          </AppliedFiltersSection>
        ) : ''
      }
    </div>
  )
}